import CategoryOption from "./CategoryOption";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getAllCategories } from "../../api/category.api";
import { AuthData } from "../../pages/Authorization/AuthWrapper";
import { MdOutlineAddCircleOutline   } from "react-icons/md";
import { showError } from "../../services/toastServices";

function CategoriesSectionSidebar() {
    const[selectedOption, setSelectedOption] = useState('');
    const[categories, SetCategories] = useState([])
    const location = useLocation();

    const { user, refreshTrigger } = AuthData();

    const handleOptionSelection = (to) => {
        setSelectedOption(to)
    }
    useEffect(() => {
        async function loadCategories() {
            if(user.isAuthenticated){
                await getAllCategories(successGetCategories, errorGetCategories);
            }
        }

        loadCategories();
    }, [user, refreshTrigger])

    useEffect(() => {
        const isCategoryRoute = location.pathname.startsWith('/category-projects/');
        setSelectedOption(isCategoryRoute ? location.pathname : '');
    }, [location.pathname])

    const successGetCategories = ((response)=>{
        SetCategories(response.data.items);
    })
    const errorGetCategories = ((error)=>{
        showError('Error al cargar categorías')
    })

    const renderCategories = categories.map((category) => {

        return <div key={`sb-ct-${category.id}`} className="">
            <CategoryOption
                
                to={`/category-projects/${category.id}`}
                editTo={`/category/${category.id}`}
                category={category}
                className="mb-3"
                activeClassName="font-bold" //border-l-4 border-black pl-2
                handleOptionSelection={handleOptionSelection}
                selected={selectedOption}
            >
                
            </CategoryOption>
        </div>
    })

    const renderLoggedOutUser = (()=>{
        return(
            <div className="text-red-400 font-bold">No ha iniciado sesión.</div>
        )
    })
    const renderAddCategoryButton=(()=>{
        if(user.isAuthenticated){
            return (<a href="/category-add"><MdOutlineAddCircleOutline size={20}/></a>)
        }
    })
//sticky top-0 overflow-auto scrollbar-hide flex flex-col items-start
    return (
        <div className="">
            <div className="w-full flex flex-row mt-1">
                <div className=" text-black font-bold ">Categorías</div>
                <div className="mt-1 ml-2">{renderAddCategoryButton()}</div>
            </div>
            <div className="w-full ">
                {user.isAuthenticated ? renderCategories:renderLoggedOutUser()}
            </div>
        </div>
    )
};

export default CategoriesSectionSidebar;